import { Box, List, ListItemButton,Typography, Grid } from "@mui/material";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@mui/material/styles";

import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';


// Icon
import soladefyLogo from "../../Asset/bg/Logo.png";
import { Link } from "react-router-dom";


import homeicon from "../../Asset/Icons/homeicon.png";
import launchpadicon from "../../Asset/Icons/launchpad.png";
import gamesicon from "../../Asset/Icons/gamesicon.png";
import guildsicon from "../../Asset/Icons/guildicon.png";
import leaderboardicon from "../../Asset/Icons/leaderboardicon.png";
import stakingicon from "../../Asset/Icons/stakingicon.png";
import tiericon from "../../Asset/Icons/tiersicon.png";
import infoicon from "../../Asset/Icons/infoicon.png";

const useStyles = makeStyles((theme) => ({
  root: {
    background:
      "linear-gradient(135deg, rgba(130, 58, 224, 0.36) 0%, rgba(90, 85, 237, 0) 50%, rgba(51, 113, 250, 0.27) 100%);",
    width: "15%",
    height: 'calc(100% - 15%)',
    position:'fixed',
    margin: "2%",
    marginTop:'1%',
    paddingTop: "10px",
    paddingBottom: "50px",
    borderRadius: "60px",
    boxShadow: "30px 30px 30px 30px transparent",
    alignContent: "center",
    transform: "translate3d(0px, 20px, 0) scale(0.95)",
    fontFamily: "Inter",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  list: {
    // paddingLeft: "5%",
    width: "100%",
  },
}));

const CustomListItemButton = styled(ListItemButton)(({ theme }) => ({
    width: "100%",
    color: "gray",
  "&.Mui-selected": {
    color: "white",
    background:
      "linear-gradient(to right, rgba(115, 85, 176, 0) 0%, rgba(115, 85, 176, 0.1) 50%, rgba(115, 85, 176, 0.71) 100%)",
    borderWidth: "0px 3px 0px 0px",
    borderStyle: "solid",
    borderImage:
      "linear-gradient(to bottom, #FD00FF,white ,#FD00FF,white ,#FD00FF) 1 100%",
  },
}));


const drawerWidth = 240;

const NavBar = (props) => {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    
  };

  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
      <Grid container sx={{display:'flex'}}>
        <Grid item md={12} lg={12} xl={12}>
          <List className={classes.list}>
            <ListItemButton
              component={Link}
              to="/"
            >
              <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: "100%",
                justifyContent:'center',
                paddingTop: "2%",
                paddingBottom: "2%",
              }}
              >
              <img src={soladefyLogo} alt="SolaDefy Log0" height={"50px"} />
              </Box>
            </ListItemButton>
          </List>
        </Grid>

        <List
          component="nav"
          aria-label="main mailbox folders"
          className={classes.list}
          sx={{ paddingTop: "20%" }}
          onChange={handleListItemClick}
        >
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/"
              key={selectedIndex}
              selected={selectedIndex === 0}
              onClick={(event) => handleListItemClick(event, 0)}
              sx={{ marginTop: "2%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={homeicon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 0 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Home
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/launchpad"
              key={selectedIndex}
              selected={selectedIndex === 1}
              onClick={(event) => handleListItemClick(event, 1)}
              sx={{ marginTop: "5%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={launchpadicon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 1 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Launchpad
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/games"
              selected={selectedIndex === 2}
              onClick={(event) => handleListItemClick(event, 2)}
              sx={{ marginTop: "5%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={gamesicon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 2 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Games
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/guilds"
              selected={selectedIndex === 3}
              onClick={(event) => handleListItemClick(event, 3)}
              sx={{ marginTop: "5%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={guildsicon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 3 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Guilds
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/leaderboard"
              selected={selectedIndex === 4}
              onClick={(event) => handleListItemClick(event, 4)}
              sx={{ marginTop: "5%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={leaderboardicon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 4 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Leaderboard
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/staking"
              selected={selectedIndex === 5}
              onClick={(event) => handleListItemClick(event, 5)}
              sx={{ marginTop: "2%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={stakingicon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 5 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Staking
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/tiers"
              selected={selectedIndex === 6}
              onClick={(event) => handleListItemClick(event, 6)}
              sx={{ marginTop: "5%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={tiericon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 6 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Tiers
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <CustomListItemButton
              component={Link}
              to="/info"
              selected={selectedIndex === 7}
              onClick={(event) => handleListItemClick(event, 7)}
              sx={{ marginTop: "5%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "100%",
                  paddingLeft: "10%",
                  paddingTop: "2%",
                  paddingBottom: "2%",
                }}
              >
                <img
                  src={infoicon}
                  alt=" "
                  height="20px"
                  className={
                    selectedIndex === 7 ? "icon-active" : "icon-inactive"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    paddingLeft: "10%",
                    fontSize: "10pt",
                  }}
                >
                  Info
                </Typography>
              </Box>
            </CustomListItemButton>
          </Grid>
        </List>
      </Grid>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' },alignSelf:'flex-start' }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth,backgroundColor:'transparent'  },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth,backgroundColor:'transparent' },
          }}
          open
        >
          <Box className={classes.root}>
          {drawer}
          </Box>
        </Drawer>
      </Box>
    
    </Box>
  );
};


NavBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
}
export default NavBar;
